export default __webpack_public_path__ + "static/img/collections-men-shirts-bg.e8d961c.jpg";